import { connect } from "react-redux";
import get from "lodash/get";

import {
  getCompanies as onGetCompanies,
  setCompaniesToOwnership as onSetToOwnershitDataState,
  updateCompany as onUpdateCompany,
  createOwnershipArea as onCreateOwnershipArea,
  createCompany as onCreateCompany,
  getCompany as onGetCompany,
  transferUnitsToCompany as onTransferUnitsToCompany,
  enteringCompany as onEnteringCompany,
  downloadCompanyInfo as onDownloadCompanyInfo,
} from "../../actions/companiesActions";

const mapStateToProps = (state) => ({
  ownershipAreasDataState: state.ownershipAreas.dataState,
  createOwnershipAreaDataState: state.ownershipAreas.createOwnershipAreaDataState,
  createCompanyDataState: state.ownershipAreas.createCompanyDataState,
  updateCompanyDataState: state.ownershipAreas.updateCompanyDataState,
  setToOwnershitDataState: state.ownershipAreas.setToOwnershitDataState,
  transferUnitToCompanyDataState: state.ownershipAreas.transferUnitToCompanyDataState,
  companyDataState: state.ownershipAreas.companyDataState,
  enteringCompanyDataState: state.ownershipAreas.enteringCompanyDataState,
  downloadCompanyInfoDataState: state.ownershipAreas.downloadCompanyInfoDataState,
  company: get(state, ["ownershipAreas", "company"], null),
  ownershipAreas: get(state, ["ownershipAreas", "ownershipAreas"], {}),
});

const mapDispatchToProps = {
  onGetCompanies,
  onSetToOwnershitDataState,
  onUpdateCompany,
  onCreateOwnershipArea,
  onCreateCompany,
  onGetCompany,
  onTransferUnitsToCompany,
  onEnteringCompany,
  onDownloadCompanyInfo,
};

const withCompanies = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withCompanies };
